import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./CardWrapper.module.css";
export const CardWrapper = props => {
  const _props = {
    ...props,
    className: `${props.className} ${styles.container}`
  };
  return _jsx("div", {
    ..._props,
    children: props.children
  });
};